import type { Evidence } from '@/composables/useOrderConversation';

/**
 * An ELSA answer, split for rendering (AB#21422).
 *
 * Paragraphs on blank lines or newlines; within each, text and [n] markers.
 * A marker whose n has no evidence entry is dropped from the output — the
 * backend already strips those, so this is belt and braces, and it means a
 * chip on screen always has a quote behind it.
 */
export interface AnswerPart {
  text: string;
  n: number | null;
  evidence: Evidence | null;
}

export const splitAnswer = (text: string, evidence: Evidence[]): AnswerPart[][] => {
  const byN = new Map<number, Evidence>(evidence.map((e) => [e.n, e]));

  return text
    .split(/\n+/)
    .map((p) => p.trim())
    .filter((p) => p !== '')
    .map((p) => {
      const parts: AnswerPart[] = [];
      const re = /\s?\[(\d{1,2})\]/g;
      let last = 0;
      let m: RegExpExecArray | null;

      while ((m = re.exec(p)) !== null) {
        const n = Number(m[1]);
        const ev = byN.get(n) ?? null;

        if (m.index > last) parts.push({ text: p.slice(last, m.index), n: null, evidence: null });
        if (ev) parts.push({ text: '', n, evidence: ev });
        last = m.index + m[0].length;
      }

      if (last < p.length) parts.push({ text: p.slice(last), n: null, evidence: null });

      return parts;
    });
};
